(() => {
    const hpProject = document.querySelector(".hp-project");

  
    // callback is called on intersection change
    const onIntersection = (entries, opts) => {
      entries.forEach((entry) =>
        entry.target.classList.toggle("visible", entry.isIntersecting)
      );
    };
  
    const seeScroll = () => {
      let observer = new IntersectionObserver(onIntersection, {
        root: null, // default is the viewport
        threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
      });
  
      observer.observe( hpProject );
      // observer.unobserve(entry.target);
    };
  
    const init = () => {
      if (hpProject) {
        seeScroll();
      }
    };
  
    init();
  })();
  